import { createAction } from 'typesafe-actions';
import {
    CLEAR_ALL_FILTERS,
    UPDATE_DYNAMIC_FILTER,
    SET_DYNAMIC_FILTERS,
    UPDATE_SEARCH_TERM,
    UPDATE_STARTS_WITH,
    INIT_FILTER_STATE,
    SET_ACTIVE_PAGE,
    RESET_ACTIVE_PAGE,
} from './filterConstants';
import { Dispatch } from 'redux';
import { DynamicFilterValues } from './filterReducer';
import { HydratedCurriculumType } from '../Common/types/AppConfigTypes';
import { curriculumTypesSelector } from '../AppConfig/appConfigSelectors';
import { activeCTSlugSelector } from '../List/listSelectors';
import { GetState } from '../Common/store/rootReducer';

export const initializeFilterStateAction = createAction(INIT_FILTER_STATE)<
    HydratedCurriculumType[]
>();

export const initFilterState = () => (
    dispatch: Dispatch,
    getState: GetState,
) => {
    const state = getState();
    const curriculumTypes = curriculumTypesSelector(state);

    dispatch(initializeFilterStateAction(curriculumTypes));
};

export const updateSearchTermAction = createAction(UPDATE_SEARCH_TERM)<{
    searchTerm: string;
    activeCTSlug: string;
}>();

export const updateSearchTerm = (searchTerm: string) => (
    dispatch: Dispatch,
    getState: GetState,
) => {
    const state = getState();
    const activeCTSlug = activeCTSlugSelector(state);
    dispatch(resetActivePageAction({ activeCTSlug }));
    dispatch(updateSearchTermAction({ searchTerm, activeCTSlug }));
};

export const updateStartsWithAction = createAction(UPDATE_STARTS_WITH)<{
    startsWith: string;
    activeCTSlug: string;
}>();

export const updateStartsWith = (startsWith: string) => (
    dispatch: Dispatch,
    getState: GetState,
) => {
    let activeCTSlug = '';
    try {
        const state = getState();
        activeCTSlug = activeCTSlugSelector(state);
    } catch (e) {
        console.error(e);
    }
    dispatch(resetActivePageAction({ activeCTSlug }));
    dispatch(updateStartsWithAction({ startsWith, activeCTSlug }));
};

export const updateDynamicFilterAction = createAction(UPDATE_DYNAMIC_FILTER)<{
    dynamicFilterIndex: number;
    value: string;
    activeCTSlug: string;
}>();

export const updateDynamicFilter = (
    dynamicFilterIndex: number,
    value: string,
) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const activeCTSlug = activeCTSlugSelector(state);
    dispatch(
        updateDynamicFilterAction({ dynamicFilterIndex, value, activeCTSlug }),
    );
    dispatch(updateStartsWithAction({ startsWith: '', activeCTSlug }));
};

export const setDynamicFiltersAction = createAction(SET_DYNAMIC_FILTERS)<{
    dynamicFilterValues: DynamicFilterValues;
    activeCTSlug: string;
}>();

export const setDynamicFilters = (dynamicFilterValues: DynamicFilterValues) => (
    dispatch: Dispatch,
    getState: GetState,
) => {
    const state = getState();
    const activeCTSlug = activeCTSlugSelector(state);

    dispatch(
        setDynamicFiltersAction({
            dynamicFilterValues,
            activeCTSlug,
        }),
    );
};

export const clearAllFiltersAction = createAction(CLEAR_ALL_FILTERS)<{
    activeCTSlug: string;
}>();

export const clearAllFilters = () => (
    dispatch: Dispatch,
    getState: GetState,
) => {
    const state = getState();
    const activeCTSlug = activeCTSlugSelector(state);
    dispatch(clearAllFiltersAction({ activeCTSlug }));
};

export const setActivePageAction = createAction(SET_ACTIVE_PAGE)<{
    activeCTSlug: string;
    activePageIndex: number;
}>();

export const setActivePage = (activePageIndex: number) => (
    dispatch: Dispatch,
    getState: GetState,
) => {
    const state = getState();
    const activeCTSlug = activeCTSlugSelector(state);
    dispatch(setActivePageAction({ activeCTSlug, activePageIndex }));
};

export const resetActivePageAction = createAction(RESET_ACTIVE_PAGE)<{
    activeCTSlug: string;
}>();
